var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.isOn ? 'kaiGuan1' : 'kaiGuan2'})}
var staticRenderFns = []

export { render, staticRenderFns }